import axios from "axios";

const axiosConfig = axios.create({
    baseURL: "https://lhstoolkit.learninghealthcareproject.co.uk/", // toolkitData.root_url,
});

export default axiosConfig;